<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户导出记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <RecordList :category="1"></RecordList>
    </div>
  </div>
</template>

<script>
import RecordList from './list'

export default {
  components: {
    RecordList,
  },
}
</script>